/* unplugin-vue-components disabled */import { render } from "./footnote.vue?vue&type=template&id=0bf24d90&scoped=true"
import script from "./footnote.vue?vue&type=script&lang=js"
export * from "./footnote.vue?vue&type=script&lang=js"

import "./footnote.vue?vue&type=style&index=0&id=0bf24d90&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf24d90"],['__file',"src/controls/footnote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bf24d90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bf24d90', __exports__)) {
    api.reload('0bf24d90', __exports__)
  }
  
  module.hot.accept("./footnote.vue?vue&type=template&id=0bf24d90&scoped=true", () => {
    api.rerender('0bf24d90', render)
  })

}


export default __exports__